var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPwa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 938,
    width: 2500,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -1.741 256 97.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165.35 96.185L204.209 0h-25.761l-26.58 62.157L132.964 0h-19.802L92.868 62.157 78.555 33.833 65.603 73.66l13.15 22.526h25.353l18.34-55.741 17.486 55.741z",
    fill: "#fb8c00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.393 63.166H40.22c4.795 0 9.064-.535 12.808-1.606l4.094-12.618 11.44-35.264a28.175 28.175 0 00-2.986-3.92C59.704 3.253 51.109 0 39.794 0H0v96.185h24.393zm20.95-41.038c2.295 2.31 3.442 5.402 3.442 9.276 0 3.903-1.01 6.998-3.027 9.286-2.212 2.542-6.285 3.813-12.219 3.813h-9.146v-25.84h9.214c5.53 0 9.442 1.155 11.737 3.465zm143.08 56.83l7.395-18.663h21.348l-10.131-28.31L219.707 0 256 96.185h-26.766l-6.201-17.227z",
    fill: "#616161"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwa);
export default __webpack_public_path__ + "static/media/pwa.da3d2b75ea4646ab71a6f2069aeb7a6b.svg";
export { ForwardRef as ReactComponent };